<template>
  <div class="input-slider">
    <vue-slider
      v-model="currentValue"
      :height="40"
      :min="min"
      :max="max"
      :interval="step"
      :tooltip="'always'"
      :marks="marks"
    >
      <template v-slot:tooltip="{ value, focus }">
        <div :class="['custom-tooltip', { focus }]">
          <div class="d-flex flex-row flex-fill align-self-center">
            <div class="text-left">&lt;</div>
            <div class="text-center ml-auto mr-auto">
              {{ replaceDotWithComma(value) }}
            </div>
            <div class="text-right">&gt;</div>
          </div>
        </div>
      </template>
      <template v-slot:label="{ label, active }">
        <div :class="['vue-slider-mark-label', 'custom-label', { active }]">
          {{ replaceDotWithComma(label) }}
        </div>
      </template>
    </vue-slider>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import { replaceDotWithComma } from "../utils/generic.utils";

export default {
  name: "InputSpinner",
  components: { VueSlider },
  value: "",
  props: {
    disabled: Boolean,
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    value: {
      required: true
    },
    step: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      marks: val => val === this.max || val === this.min,
      currentValue: this.value
    };
  },

  watch: {
    currentValue(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    replaceDotWithComma(value) {
      return replaceDotWithComma(value);
    }
  }
};
</script>

<style></style>
